import * as React from 'react';
import { ContentfulImage } from '../ContentfulImage/ContentfulImage.esm.js';
import { InvitaeIcon } from '../Icon/InvitaeIcon.esm.js';

var ImageOrIcon = function (_a) {
    var icon = _a.icon, image = _a.image, role = _a.role;
    if (image) {
        return React.createElement(ContentfulImage, { asset: image, imageAnimation: "none", role: role });
    }
    if (icon) {
        return React.createElement(InvitaeIcon, { iconName: icon });
    }
    return null;
};

export { ImageOrIcon, ImageOrIcon as default };
//# sourceMappingURL=ImageOrIcon.esm.js.map
